"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameRotation = void 0;
var GameRotation;
(function (GameRotation) {
    GameRotation["Clockwise"] = "clockwise";
    GameRotation["CounterClockwise"] = "counterclockwise";
})(GameRotation || (exports.GameRotation = GameRotation = {}));
